module.exports = __webpack_public_path__ + "media/images/riders/small/MALENE_DEGN-4cbb59a19508a60082681d0f5ebd87c4.png";